// src/pages/xray/XrayLobby/TabEdgeview.js
import React from 'react';

const TabEdgeview = ({
  selectedTabsEdgeview,
  setSelectedTabsEdgeview,
  syslogHostStatus,
}) => {
  return (
    <>
      <div className="tabs mt-6 flex border-b">
        {['SYSLOG'].map((label, index) => (
          <label
            key={index}
            className={`cursor-pointer px-2 py-1 border-t border-r border-l border-red-600 bg-red-300 ml-1 rounded-t-md ${
              selectedTabsEdgeview === `tabsEdgeview${index + 1}`
                ? 'border-b-0 font-bold'
                : 'border-red-600 bg-red-600 hover:bg-red-700 transition-colors duration-200 text-white'
            }`}
          >
            <input
              type="radio"
              className="hidden"
              name="tabs-group"
              checked={selectedTabsEdgeview === `tabsEdgeview${index + 1}`}
              onChange={() =>
                setSelectedTabsEdgeview(`tabsEdgeview${index + 1}`)
              }
            />
            {label}
          </label>
        ))}
      </div>

      <div className="px-6 py-2 bg-white shadow-lg rounded-lg">
        {selectedTabsEdgeview === 'tabsEdgeview1' && (
          <div>
            <h1 className="font-bold text-2xl p-2">Edgeview 1 or Edgeview2</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {syslogHostStatus || 'No Edgeview status available'}
            </pre>
            <p className="bg-blue-200 p-4 rounded-md border mt-2">
              The Edgeview System can hold up to <strong>30 days</strong> of
              syslog from the Edgemarcs before it rotates the oldest logs to be
              replaced by newest logs.
              <a
                className="hover:text-blue-900 text-blue-600"
                href="https://ewn.my.salesforce-sites.com/kb/articles/KnowledgeBase_Solution/10328 "
                target="_blank"
                rel="noopener noreferrer"
              >
                https://ewn.my.salesforce-sites.com/kb/articles/KnowledgeBase_Solution/10328
              </a>
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default TabEdgeview;
